import React from "react";
import Styled from "styled-components";
import { Collapsible, CollapsibleContent, CollapsibleSummary, CollapsibleSummaryButton, } from "@vp/swan";
import { useProductOptionContext } from "../context";
const DebugContainer = Styled.div `
  width: 100%;
  height: 10em;
  overflow: scroll;
  background-color: #111111;
  color: white;
  
  > pre { 
    margin: 0;
    padding: 0.2em 0;
    border-bottom: 1px solid #888888;
  }
`;
export const ProductOptionDebug = () => {
    const { decoratorMutations, validationMessages } = useProductOptionContext();
    return (React.createElement(Collapsible, { style: {
            borderStyle: "dashed",
            borderWidth: "1px",
            borderColor: "black",
            borderRadius: "0.5em",
            backgroundImage: "linear-gradient(45deg, #e0e0e0 25%, #e8e8e8 25%, #e8e8e8 50%, #e0e0e0 50%, #e0e0e0 75%, #e8e8e8 75%, #e8e8e8 100%)",
            backgroundSize: "56.57px 56.57px",
        } },
        React.createElement(CollapsibleSummary, { m: 0, p: "2", pr: "4", style: { borderStyle: "none", borderWidth: 0, borderColor: "transparent" } },
            React.createElement(CollapsibleSummaryButton, { m: "2", p: "2" },
                React.createElement("pre", { style: { margin: "0" } }, "Debug Info"))),
        React.createElement(CollapsibleContent, { px: "4", p: "2", style: { position: "relative" } },
            React.createElement(DebugContainer, null,
                React.createElement("pre", null, "Validations:"),
                React.createElement("pre", null, JSON.stringify(validationMessages, null, 2)),
                React.createElement("pre", null, "Mutations:"),
                React.createElement("pre", null, JSON.stringify(decoratorMutations, null, 2))))));
};
//# sourceMappingURL=product-option-debug.js.map